module.exports = __webpack_public_path__ + "img/shipment-warning.fd2ec905.svg";